module.exports = __webpack_public_path__ + "img/Skirt-Front-B2-Db-Fc-Ge-Hc-Ia.7faa2f15.png";